"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../zustandStore");
const linkAndApprovals_1 = __importDefault(require("./linkAndApprovals"));
const supportContainer_1 = __importDefault(require("./supportContainer"));
const supportFeatures_1 = __importDefault(require("./supportFeatures"));
const SupportSettings = () => {
    const { companyFeatures } = (0, react_router_1.useLoaderData)();
    const { setCompanyFeatures } = (0, zustandStore_1.useZustand)(state => ({
        setCompanyFeatures: state.setCompanyFeatures,
    }));
    (0, react_1.useEffect)(() => {
        setCompanyFeatures(companyFeatures);
    }, [companyFeatures]);
    return ((0, jsx_runtime_1.jsx)(supportContainer_1.default, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: {
                    xs: 12,
                    md: 8,
                    lg: 8,
                }, children: [(0, jsx_runtime_1.jsx)(supportFeatures_1.default, {}), (0, jsx_runtime_1.jsx)(linkAndApprovals_1.default, {})] }) }) }));
};
exports.default = SupportSettings;
